module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.01-11448b5f2d276f52905591e2f4767677.svg";